import type { Locale } from "utils/dateFormat";
import type { ReplyMute } from "types/ReplyMute";

function formatUntil(until: string, locale: Locale): string {
  const date = new Date(until);
  const now = new Date();
  const sameDay =
    date.getFullYear() === now.getFullYear() &&
    date.getMonth() === now.getMonth() &&
    date.getDate() === now.getDate();
  const tag = locale === "es" ? "es-ES" : "en-US";
  if (sameDay) {
    return date.toLocaleTimeString(tag, { hour: "2-digit", minute: "2-digit" });
  }
  return date.toLocaleString(tag, {
    day: "numeric",
    month: "short",
    hour: "2-digit",
    minute: "2-digit",
  });
}

export function replyMuteLabel(
  mute: ReplyMute | null | undefined,
  locale: Locale,
): string | null {
  if (!mute) return null;
  if (!mute.until) {
    return locale === "es" ? "Eloria no responde" : "Eloria is not replying";
  }
  const when = formatUntil(mute.until, locale);
  if (mute.source === "manual") {
    return locale === "es"
      ? `Eloria pausada hasta ${when}`
      : `Eloria paused until ${when}`;
  }
  return locale === "es"
    ? `Eloria no responde hasta ${when}`
    : `Eloria not replying until ${when}`;
}
